import {Injectable} from '@angular/core';
import {DocumentosResource} from './documentos.resource';
import {CategoriaDocumentoModel} from './categoria-documento.model';
import {DocumentosModel} from './documentos.model';

@Injectable({
  providedIn: 'root'
})
export class DocumentosService {
  constructor(private documentosResource: DocumentosResource) {
  }

  public lodListaCategoriasDocumento(tramiteId: string): Promise<CategoriaDocumentoModel[]> {
    return this.documentosResource.lodListaCategoriasDocumento({tramite_id: tramiteId});
  }

  public crtMasivaCategoriaDocumento(categorias: CategoriaDocumentoModel[]) {
    return this.documentosResource.insercionMasivaCategoriaDocumento(categorias);
  }

  public updCategoriaDocumento(categoria: CategoriaDocumentoModel) {
    return this.documentosResource.updCategoriaDocumento(categoria);
  }

  public dltCategoriaDocumento(id: string) {
    return this.documentosResource.dltCategoriaDocumento({id: id});
  }

  public lodListaDocumentos(tramiteFilter: any): Promise<DocumentosModel[]> {
    return this.documentosResource.lodListaDocumentos(tramiteFilter);
  }

  public lodDocumento(id: string): Promise<DocumentosModel> {
    return this.documentosResource.lodDocumento({id: id});
  }

  public crtDocumento(documento: DocumentosModel) {
    return this.documentosResource.insercionDocumento(documento);
  }

  public updDocumento(documento: DocumentosModel) {
    return this.documentosResource.updDocumento(documento);
  }

  public dltDocumento(id: string) {
    return this.documentosResource.dltDocumento({id: id});
  }

  public lodDocumentosPublic(id: string): Promise<DocumentosModel[]> {
    return this.documentosResource.lodDocumentosPublic({id: id});
  }
}
